module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-60x60-69be9e432e05ae6ada6c11ef60179b6c.png";